/**
 * LCD Character Designer v6 — Vanilla JS for Shopify
 * HD44780 1602/2004 Custom + Big Characters
 * Usage: <div class="lcd-character-designer"></div>
 */
(function(){
'use strict';
var mg=function(c,r){var g=[];for(var i=0;i<r;i++){g[i]=[];for(var j=0;j<c;j++)g[i][j]=0;}return g;};
var cg=function(g){return g.map(function(r){return r.slice();});};
function S(){var rows=[];for(var i=0;i<arguments.length;i++)rows.push(arguments[i].split('').map(function(c){return c==='#'?1:0;}));return rows;}

/* ═══ HD44780 FONT ═══ */
var HF={};
var fd={' ':[0,0,0,0,0,0,0,0],A:[14,17,17,31,17,17,0,0],B:[30,17,30,17,17,30,0,0],C:[14,17,16,16,17,14,0,0],D:[30,17,17,17,17,30,0,0],E:[31,16,30,16,16,31,0,0],F:[31,16,30,16,16,16,0,0],G:[14,17,16,19,17,14,0,0],H:[17,17,31,17,17,17,0,0],I:[14,4,4,4,4,14,0,0],J:[1,1,1,1,17,14,0,0],K:[17,18,28,18,17,17,0,0],L:[16,16,16,16,16,31,0,0],M:[17,27,21,17,17,17,0,0],N:[17,25,21,19,17,17,0,0],O:[14,17,17,17,17,14,0,0],P:[30,17,17,30,16,16,0,0],Q:[14,17,17,21,18,13,0,0],R:[30,17,17,30,18,17,0,0],S2:[14,16,14,1,17,14,0,0],T:[31,4,4,4,4,4,0,0],U:[17,17,17,17,17,14,0,0],V:[17,17,17,17,10,4,0,0],W:[17,17,17,21,21,10,0,0],X:[17,10,4,10,17,17,0,0],Y:[17,10,4,4,4,4,0,0],Z:[31,1,2,4,8,31,0,0],a:[0,0,14,1,15,17,15,0],b:[16,16,22,25,17,17,30,0],c:[0,0,14,16,16,17,14,0],d:[1,1,13,19,17,17,15,0],e:[0,0,14,17,31,16,14,0],f:[6,9,8,28,8,8,8,0],g:[0,0,15,17,15,1,14,0],h:[16,16,22,25,17,17,17,0],i:[4,0,12,4,4,4,14,0],j:[2,0,6,2,2,18,12,0],k:[16,16,18,20,24,20,18,0],l:[12,4,4,4,4,4,14,0],m:[0,0,26,21,21,17,17,0],n:[0,0,22,25,17,17,17,0],o:[0,0,14,17,17,17,14,0],p:[0,0,30,17,30,16,16,0],q:[0,0,13,19,15,1,1,0],r:[0,0,22,25,16,16,16,0],s:[0,0,15,16,14,1,30,0],t:[8,8,28,8,8,9,6,0],u:[0,0,17,17,17,19,13,0],v:[0,0,17,17,17,10,4,0],w:[0,0,17,17,21,21,10,0],x:[0,0,17,10,4,10,17,0],y:[0,0,17,17,15,1,14,0],z:[0,0,31,2,4,8,31,0]};
'0123456789'.split('').forEach(function(ch,i){
var dd=[[14,17,19,21,25,17,14,0],[4,12,4,4,4,4,14,0],[14,17,1,2,4,8,31,0],[14,17,1,6,1,17,14,0],[2,6,10,18,31,2,2,0],[31,16,30,1,1,17,14,0],[6,8,16,30,17,17,14,0],[31,1,2,4,4,4,4,0],[14,17,17,14,17,17,14,0],[14,17,17,15,1,2,12,0]];
fd[ch]=dd[i];});
var punc={':':[0,0,4,0,0,4,0,0],'.':[0,0,0,0,0,12,12,0],',':[0,0,0,0,12,4,8,0],'-':[0,0,0,31,0,0,0,0],'!':[4,4,4,4,4,0,4,0],'?':[14,17,1,2,4,0,4,0],'/':[0,1,2,4,8,16,0,0],'=':[0,0,31,0,31,0,0,0],'+':[0,4,4,31,4,4,0,0],'*':[0,4,21,14,21,4,0,0],'(':[2,4,8,8,8,4,2,0],')':[8,4,2,2,2,4,8,0],"'":[4,4,0,0,0,0,0,0],'"':[10,10,0,0,0,0,0,0],'_':[0,0,0,0,0,0,31,0],'|':[4,4,4,4,4,4,4,0]};
Object.keys(punc).forEach(function(k){fd[k]=punc[k];});
fd['S']=fd['S2'];delete fd['S2'];
Object.keys(fd).forEach(function(ch){HF[ch]=[];var d=fd[ch];for(var r=0;r<8;r++){var row=[];var v=d[r]||0;for(var c=0;c<5;c++)row.push((v>>(4-c))&1);HF[ch].push(row);}});

/* ═══ SYMBOL LIBRARY ═══ */
var SYM={
'Arrows':{'Up':S('..#..','#####','.###.','..#..','..#..','..#..','.....','....'),'Down':S('..#..','..#..','..#..','.###.','#####','..#..','.....','....'),'Left':S('..#..','#....','.#...','..#..','..#..','.....','.....','.....'),
'Right':S('..#..','....#','...#.','..#..','..#..','.....','.....','.....'),
'Return':S('..#..','#....','.#...','..###','..#..','.....','.....','.....'),
'Scroll':S('.###.','.#.#.','.#.#.','.###.','.#.#.','.#.#.','.###.','....')},
'Faces':{'Happy':S('.....','.#.#.','.....','.....','#...#','.###.','.....','.....'),
'Sad':S('.....','.#.#.','.....','.....','.###.','#...#','.....','.....'),
'Wink':S('.....','.#...','.....','.....','.#.#.','..#..','.....','.....'),
'Cool':S('.....','.#.#.','#####','.....','.....','#...#','.###.','....'),
'Skull':S('.###.','#.#.#','#####','.#.#.','.###.','.....','.....','.....'),
'Alien':S('.###.','#.#.#','#.#.#','.###.','..#..','.###.','.....','....')},
'Hearts & Stars':{'Heart':S('.....','.#.#.','#####','#####','.###.','..#..','.....','.....'),
'Heart Sm':S('.....','.....','.....','.#.#.','..#..','.....','.....','....'),
'Broken':S('.....','.#.#.','##.##','#.#.#','.###.','..#..','.....','.....'),
'Star':S('..#..','.###.','#####','.###.','.#.#.','#...#','.....','.....'),
'Diamond':S('..#..','.###.','#####','.###.','..#..','.....','.....','....'),
'Club':S('..#..','.###.','..#..','#####','.###.','..#..','.###.','....')},
'Music & Sound':{'Note':S('..#..','..##.','..#.#','..#..','..#..','.##..','##...','.....'),
'Speaker':S('....#','..#.#','.####','####.','#####','.####','..#.#','....#'),
'Mute':S('....#','..#.#','.####','###.#','##.#.','#####','.####','..#.#')},
'Battery & Power':{'Full':S('.###.','#####','#####','#####','#####','#####','#####','.....'),
'75%':S('.###.','#...#','#####','#####','#####','#####','#####','.....'),
'50%':S('.###.','#...#','#...#','#...#','#####','#####','#####','.....'),
'25%':S('.###.','#...#','#...#','#...#','#...#','#...#','#####','.....'),
'Empty':S('.###.','#...#','#...#','#...#','#...#','#...#','#####','.....'),
'Charging':S('.###.','#..##','#.#.#','#####','#.#.#','##..#','#####','.....'),
'Bolt':S('...#.','..#..','.###.','..#..','.#...','#....','.....','.....'),
'Plug':S('.....','.#.#.','.#.#.','#####','#####','.###.','..#..','....')},
'Signal & WiFi':{'Sig 1':S('.....','.....','.....','.....','.....','.....','#....','....'),
'Sig 2':S('.....','.....','.....','.....','##...','##...','##...','....'),
'Sig 3':S('.....','.....','.###.','.###.','####.','####.','####.','....'),
'Sig Max':S('....#','...##','..###','..###','.####','.####','#####','....'),
'WiFi':S('..#..','.###.','#.#.#','..#..','.###.','..#..','.....','.....'),
'Antenna':S('..#..','..#..','..#..','..#..','#.#.#','.###.','.....','....'),
'BT':S('..#..','..##.','#.#.#','.##..','#.#.#','..##.','..#..','....')},
'Progress':{'Empty':S('#####','#....','#....','#....','#....','#....','#####','.....'),
'1/5':S('#####','##...','##...','##...','##...','##...','#####','.....'),
'2/5':S('#####','###..','###..','###..','###..','###..','#####','.....'),
'3/5':S('#####','####.','####.','####.','####.','####.','#####','.....'),
'Block':S('#####','#####','#####','#####','#####','#####','#####','.....'),
'4/5':S('#####','#####','#####','#####','#####','#####','#####','.....')},
'Weather':{'Sun':S('..#..','#.#.#','.###.','###.#','.###.','#.#.#','..#..','....'),
'Cloud':S('..##.','.####','#####','#####','.....','.....','.....','....'),
'Rain':S('.###.','#####','.....','.#.#.','#.#..','.....','.....','....'),
'Moon':S('..##.','..###','.####','.####','.####','..###','..##.','.....'),
'Thermo':S('..#..','.#.#.','.#.#.','.#.#.','.#.#.','#####','#####','.###.')},
'UI Elements':{'Check':S('....#','...#.','..#..','#.#..','..#..','.....','.....','....'),
'Cross':S('.....','.#.#.','..#..','..#..','.#.#.','.....','.....','....'),
'Lock':S('.###.','.#.#.','#####','##.##','##.##','#####','.....','.....'),
'Unlock':S('.###.','.#..#','#####','##.##','##.##','#####','.....','.....'),
'Home':S('..#..','.###.','#####','.###.','.#.#.','.#.#.','.....','.....'),
'Gear':S('.#.#.','#####','.#.#.','##.##','.#.#.','#####','.#.#.','.....'),
'Clock':S('.###.','#.#.#','#.##.','#...#','#...#','.###.','.....','.....'),
'Mail':S('.....','#####','##.##','#.#.#','##.##','#####','.....','.....'),
'Bell':S('..#..','.###.','.###.','.###.','#####','.....','.###.','....'),
'Trash':S('.###.','.....','#####','.#.#.','.#.#.','.#.#.','#####','.....'),
'Eye':S('.....','.###.','#.#.#','##.##','#.#.#','.###.','.....','.....'),
'Person':S('..#..','.###.','..#..','#####','..#..','.#.#.','#...#','....'),
'Flag':S('#####','##..#','####.','#....','.....','.....','.....','....'),
'Pin':S('..#..','.###.','#.#.#','.###.','..#..','..#..','.....','.....'),
'Hourglass':S('#####','.###.','..#..','..#..','..#..','.###.','#####','.....'),
'DegC':S('##.##','..#..','..#..','..#..','...##','.....','.....','....'),
'DegF':S('##.##','..###','..#..','..##.','..#..','.....','.....','....')}
};

/* ═══ BIG DIGIT PRESETS (15×16) ═══ */
function mkBD(p){return p.map(function(r){var s=r;while(s.length<15)s+='.';return s.split('').map(function(c){return c==='#'?1:0;});});}
var BD16={
'0':mkBD(['..###########..','..###########..','###.........###','###.........###','###....###..###','###...###...###','###..###....###','###.###.....###','###.........###','###.........###','###.........###','###.........###','###.........###','..###########..','..###########..','...............']),
'1':mkBD(['......###......','...######......','..####.###.....','......###......','......###......','......###......','......###......','......###......','......###......','......###......','......###......','......###......','......###......','...#########...','...#########...','...............']),
'2':mkBD(['..###########..','..###########..','###.........###','###.........###','............###','...........###.','..........###..','........###....','......###......','....###........','..###..........','###............','###############','###############','###############','...............']),
'3':mkBD(['..###########..','..###########..','###.........###','............###','............###','............###','....#########..','....#########..','............###','............###','............###','###.........###','###.........###','..###########..','..###########..','...............']),
'4':mkBD(['###.........###','###.........###','###.........###','###.........###','###.........###','###.........###','###############','###############','.............##','.............##','.............##','.............##','.............##','.............##','.............##','...............']),
'5':mkBD(['###############','###############','###............','###............','###............','###############','###############','............###','............###','............###','............###','###.........###','###.........###','..###########..','..###########..','...............']),
'6':mkBD(['..###########..','..###########..','###............','###............','###............','###############','###############','###.........###','###.........###','###.........###','###.........###','###.........###','###.........###','..###########..','..###########..','...............']),
'7':mkBD(['###############','###############','............###','...........###.','..........###..','........###....','......###......','......###......','......###......','......###......','......###......','......###......','......###......','......###......','......###......','...............']),
'8':mkBD(['..###########..','..###########..','###.........###','###.........###','###.........###','..###########..','..###########..','###.........###','###.........###','###.........###','###.........###','###.........###','###.........###','..###########..','..###########..','...............']),
'9':mkBD(['..###########..','..###########..','###.........###','###.........###','###.........###','###.........###','..############.','..############.','............###','............###','............###','............###','............###','..###########..','..###########..','...............']),
':':mkBD(['...............','...............','...............','......###......','......###......','......###......','...............','...............','...............','......###......','......###......','......###......','...............','...............','...............','...............']),
'-':mkBD(['...............','...............','...............','...............','...............','...............','..###########..','..###########..','...............','...............','...............','...............','...............','...............','...............','...............']),
'.':mkBD(['...............','...............','...............','...............','...............','...............','...............','...............','...............','...............','...............','...............','......###......','......###......','......###......','...............'])
};

var LC={green:{bg:'#5c8a2f',on:'#1a2e0a',off:'#4a7a22',fr:'#3a3a3a'},blue:{bg:'#0a3d6b',on:'#b0d4f1',off:'#0c4a7d',fr:'#2a2a4a'},yellow:{bg:'#b0a030',on:'#2a2800',off:'#9a8a28',fr:'#3a3a2a'}};

function initLCD(root){
  var mode='single',slots=[],act=0,bigGrid=mg(15,16);
  var lcdType='16x2',lcdClr='green',dk=false,showLib=false;
  var dispTxt='Custom: \\0 \\1 \\2';
  var painting=false,paintVal=1;
  var theme=localStorage.getItem('lcd-theme')||'light';dk=theme==='dark';
  for(var si=0;si<8;si++)slots.push(mg(5,8));
  var cachedWidth=root.offsetWidth||700;
  var cachedDsz={};
  function calcDsz(cols){var ww=cachedWidth-72;return Math.max(2,Math.min(8,Math.floor((ww-(cols-1)*3-24-cols*6)/(cols*5))));}
  function updateDsz(){cachedWidth=root.offsetWidth||700;cachedDsz={'16':calcDsz(16),'20':calcDsz(20)};}
  updateDsz();
  window.addEventListener('resize',function(){var oldW=cachedWidth;updateDsz();if(oldW!==cachedWidth)render();});

  function q(s){return root.querySelector(s);}
  function qa(s){return root.querySelectorAll(s);}
  function lc(){return LC[lcdClr];}
  function lCols(){return lcdType==='20x4'?20:16;}
  function lRows(){return lcdType==='20x4'?4:2;}

  /* Dot character HTML */
  function dotHTML(grid,sz){
    var c=lc(),gap=sz>3?1:0;
    var h='<div class="lcd-dc" style="display:inline-grid;grid-template-columns:repeat(5,'+sz+'px);grid-template-rows:repeat(8,'+sz+'px);gap:'+gap+'px;line-height:0">';
    for(var r=0;r<8;r++)for(var cc=0;cc<5;cc++){
      var on=grid[r]?grid[r][cc]:0;
      h+='<div style="width:'+sz+'px;height:'+sz+'px;border-radius:'+(sz>4?1:0)+'px;background:'+(on?c.on:c.off)+'"></div>';
    }
    return h+'</div>';
  }

  /* LCD display HTML */
  function lcdDisplayHTML(charFn){
    var c=lc(),cols=lCols(),rows=lRows();
    var dsz=cachedDsz[String(cols)]||6;
    var h='<div style="overflow-x:auto;padding-bottom:4px"><div style="background:'+c.fr+';border-radius:10px;padding:10px;display:inline-block;box-shadow:inset 0 2px 8px rgba(0,0,0,.3)">';
    h+='<div style="background:'+c.bg+';border-radius:6px;padding:6px;border:2px solid '+(dk?'#555':'#666')+'">';
    for(var r=0;r<rows;r++){
      h+='<div style="display:flex;gap:3px;margin-bottom:'+(r<rows-1?'4':'0')+'px">';
      for(var cc=0;cc<cols;cc++){
        var g=charFn(r,cc);
        h+='<div style="background:'+c.off+';border-radius:1px;padding:0;line-height:0">'+dotHTML(g,dsz)+'</div>';
      }
      h+='</div>';
    }
    h+='</div></div></div>';return h;
  }

  function parseDisp(){
    var ch=[],i=0,t=dispTxt;
    while(i<t.length){if(t[i]==='\\'&&i+1<t.length&&t[i+1]>='0'&&t[i+1]<='7'){ch.push({t:'c',s:+t[i+1]});i+=2;}else{ch.push({t:'r',ch:t[i]});i++;}}
    return ch;
  }

  function getChar(parsed,row,col){
    var ci=row*lCols()+col;var p=parsed[ci];
    if(!p)return HF[' '];if(p.t==='c')return slots[p.s]||HF[' '];return HF[p.ch]||HF[' '];
  }

  /* Split big grid into 6 slots */
  function bigSlots(){
    var out=[];
    for(var sr=0;sr<2;sr++)for(var sc=0;sc<3;sc++){
      var g=mg(5,8);for(var r=0;r<8;r++)for(var c=0;c<5;c++){var gr=sr*8+r,gc=sc*5+c;g[r][c]=bigGrid[gr]?bigGrid[gr][gc]||0:0;}
      out.push(g);}
    return out;
  }

  /* ═══ RENDER ═══ */
  function render(){
    var c=lc(),cols=lCols(),rows=lRows();
    /* Shell */
    var h='<div class="lcd-wrap'+(dk?' lcd-dark':'')+'">';
    /* Header */
    h+='<div class="lcd-header"><div><span class="lcd-logo">\u2588 LCD CHARACTER DESIGNER</span><br><span class="lcd-sub">HD44780 \xb7 1602 / 2004 \xb7 Custom + Big Characters</span></div>';
    h+='<div class="lcd-hr"><button class="lcd-btn lcd-accent" id="lcd-reset">\u21BA New</button><button class="lcd-btn" id="lcd-theme">'+(dk?'\u2600':'\u263e')+'</button></div></div>';
    /* Tabs */
    h+='<div class="lcd-tabs"><button class="lcd-tab'+(mode==='single'?' active':'')+'" data-mode="single">\ud83d\udd24 Single Characters (5\xd78)</button>';
    h+='<button class="lcd-tab'+(mode==='big'?' active':'')+'" data-mode="big">\ud83d\udd20 Big Character (15\xd716)</button></div>';
    /* Controls */
    h+='<div class="lcd-body"><div class="lcd-controls">';
    h+='<span class="lcd-label">LCD:</span>';
    ['16x2','20x4'].forEach(function(t){h+='<button class="lcd-btn lcd-sm'+(lcdType===t?' lcd-accent':'')+'" data-lcd="'+t+'">'+t+'</button>';});
    h+='<span class="lcd-sep">\u2502</span><span class="lcd-label">Backlight:</span>';
    Object.keys(LC).forEach(function(k){h+='<div class="lcd-color-dot'+(lcdClr===k?' active':'')+'" data-clr="'+k+'" style="background:'+LC[k].bg+'"></div>';});
    h+='</div>';

    if(mode==='single') h+=renderSingle();
    else h+=renderBig();

    h+='</div>';
    /* Footer */
    h+='<div class="lcd-footer">Built by <a href="https://www.eelectronicparts.com/" target="_blank" rel="noopener noreferrer">eElectronicParts</a> \u2014 Electronic Components &amp; Tools</div>';
    h+='</div>';
    root.innerHTML=h;
    bindEvents();
  }

  function renderSingle(){
    var parsed=parseDisp(),c=lc();
    var h='';
    /* LCD Display */
    h+='<div class="lcd-section"><div class="lcd-label">LCD Display ('+lcdType+') \u2014 type \\0 through \\7 to show custom characters</div>';
    h+='<input class="lcd-input lcd-mono" id="lcd-disp" value="'+dispTxt.replace(/"/g,'&quot;')+'" placeholder="Type text... \\0 through \\7 for custom chars">';
    h+=lcdDisplayHTML(function(r,cc){return getChar(parsed,r,cc);});
    h+='</div>';
    /* 8 Slots */
    h+='<div class="lcd-section"><div class="lcd-hint">8 Character Slots \u2014 click to select, then draw below:</div><div class="lcd-slots">';
    for(var i=0;i<8;i++){
      var has=slots[i].some(function(r){return r.some(function(v){return v;});});
      h+='<div class="lcd-slot'+(i===act?' active':'')+'" data-slot="'+i+'"><div class="lcd-slot-label">\\'+i+(has?' \u25cf':'')+'</div>';
      h+='<div style="background:'+c.bg+';border-radius:3px;padding:0;line-height:0;display:inline-block">'+dotHTML(slots[i],4)+'</div></div>';
    }
    h+='</div></div>';
    /* Grid + Preview */
    h+='<div class="lcd-editor"><div><div class="lcd-label">Draw \u2014 Slot \\'+act+' (5\xd78 pixels)</div>';
    h+='<div class="lcd-grid-wrap"><div class="lcd-grid" id="lcd-grid" style="grid-template-columns:repeat(5,30px);grid-template-rows:repeat(8,30px)">';
    for(var r=0;r<8;r++)for(var cc=0;cc<5;cc++){
      var on=slots[act][r][cc];
      h+='<div class="lcd-cell'+(on?' on':'')+'" data-r="'+r+'" data-c="'+cc+'"></div>';
    }
    h+='</div></div>';
    h+=toolsHTML();
    h+='</div>';
    /* LCD Preview */
    h+='<div><div class="lcd-label">LCD Preview</div><div class="lcd-char-prev" style="background:'+c.bg+';border:3px solid '+c.fr+'">'+dotHTML(slots[act],28)+'</div></div></div>';
    /* Symbol Library */
    h+=symLibHTML();
    /* Code */
    h+=codeHTML(singleCode());
    return h;
  }

  function renderBig(){
    var c=lc(),bs=bigSlots();
    var h='';
    h+='<div class="lcd-info"><strong>Big Character Mode:</strong> Draw on a 15\xd716 pixel canvas (3 cells \xd7 2 rows). Auto-splits into 6 custom character slots. Uses 6 of 8 slots. Dashed lines show cell boundaries.</div>';
    /* Presets */
    h+='<div class="lcd-section"><div class="lcd-hint">Quick-load big digit presets:</div><div class="lcd-preset-row">';
    Object.keys(BD16).forEach(function(d){h+='<button class="lcd-btn lcd-sm" data-bd="'+d+'">'+(d===':'?'colon':d==='.'?'dot':d==='-'?'dash':d)+'</button>';});
    h+='<span class="lcd-sep">\u2502</span><button class="lcd-btn lcd-sm" id="lcd-big-clear">Clear All</button></div></div>';
    /* 15×16 Canvas */
    h+='<div class="lcd-section"><div class="lcd-label">15\xd716 Canvas \u2014 dashed lines = cell boundaries</div>';
    h+='<div style="overflow-x:auto;padding-bottom:4px"><div class="lcd-grid-wrap"><div class="lcd-grid" id="lcd-big-grid" style="grid-template-columns:repeat(15,22px);grid-template-rows:repeat(16,22px)">';
    for(var r=0;r<16;r++)for(var cc=0;cc<15;cc++){
      var on=bigGrid[r][cc];
      var extraStyle='';
      if(cc%5===4&&cc<14)extraStyle+='border-right:2px dashed '+(dk?'#335':'#aab')+';';
      if(r===7)extraStyle+='border-bottom:2px dashed '+(dk?'#335':'#aab')+';';
      h+='<div class="lcd-cell'+(on?' on':'')+'" data-r="'+r+'" data-c="'+cc+'" data-big="1" style="width:22px;height:22px;'+extraStyle+'"></div>';
    }
    h+='</div></div></div>';
    h+=toolsHTML('big');
    h+='</div>';
    /* Split + LCD Preview */
    h+='<div class="lcd-editor">';
    h+='<div><div class="lcd-label">Auto-split: 6 slots (3\xd72)</div><div class="lcd-split-grid">';
    for(var i=0;i<6;i++){
      h+='<div style="background:'+c.bg+';border-radius:4px;padding:0;border:2px solid '+c.fr+';text-align:center;line-height:0">';
      h+='<div style="font-size:8px;color:'+(c.on==='#1a2e0a'?'#3a5a1a':'#8ac')+';line-height:normal;padding:2px 3px 1px">Slot '+i+'</div>';
      h+=dotHTML(bs[i],4)+'</div>';
    }
    h+='</div></div>';
    h+='<div><div class="lcd-label">LCD Display ('+lcdType+') \u2014 big char at (0,0)</div>';
    h+=lcdDisplayHTML(function(row,col){if(col<3&&row<2){return bs[row*3+col];}return HF[' '];});
    h+='</div></div>';
    /* Code */
    h+=codeHTML(bigCode(bs));
    return h;
  }

  function toolsHTML(type){
    return'<div class="lcd-tools"><button class="lcd-btn lcd-sm" data-tool="clear" data-type="'+(type||'')+'">Clear</button><button class="lcd-btn lcd-sm" data-tool="invert" data-type="'+(type||'')+'">Invert</button>'+
    '<button class="lcd-btn lcd-sm" data-tool="l" data-type="'+(type||'')+'">\u25c0</button><button class="lcd-btn lcd-sm" data-tool="r" data-type="'+(type||'')+'">\u25b6</button>'+
    '<button class="lcd-btn lcd-sm" data-tool="u" data-type="'+(type||'')+'">\u25b2</button><button class="lcd-btn lcd-sm" data-tool="d" data-type="'+(type||'')+'">\u25bc</button></div>';
  }

  function symLibHTML(){
    var h='<div class="lcd-lib"><div class="lcd-lib-header" id="lcd-lib-toggle"><span>\ud83d\udcda <strong>Symbol Library</strong> \u2014 click to load into Slot \\'+act+'</span><span class="lcd-lib-arrow'+(showLib?' open':'')+'">&#9660;</span></div>';
    if(showLib){
      h+='<div class="lcd-lib-body">';
      Object.keys(SYM).forEach(function(cat){
        h+='<div class="lcd-lib-cat"><div class="lcd-lib-cat-name">'+cat+'</div><div class="lcd-lib-items">';
        Object.keys(SYM[cat]).forEach(function(name){
          var g=SYM[cat][name];
          h+='<div class="lcd-lib-item" data-cat="'+cat+'" data-sym="'+name+'" title="'+name+'">';
          h+='<div style="background:#000;border-radius:2px;padding:2px;display:inline-block;line-height:0"><div style="display:inline-grid;grid-template-columns:repeat(5,3px);grid-template-rows:repeat(8,3px);gap:0">';
          for(var r=0;r<8;r++)for(var c=0;c<5;c++){h+='<div style="width:3px;height:3px;background:'+(g[r][c]?'#0f0':'#111')+'"></div>';}
          h+='</div></div><div class="lcd-lib-name">'+name+'</div></div>';
        });
        h+='</div></div>';
      });
      h+='</div>';
    }
    h+='</div>';return h;
  }

  function codeHTML(code){
    return'<div class="lcd-code-section"><div class="lcd-code-head"><span>Arduino Code</span><button class="lcd-btn lcd-sm" id="lcd-copy">Copy</button></div><pre class="lcd-code" id="lcd-code-pre">'+escapeHTML(code)+'</pre></div>';
  }
  function escapeHTML(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}

  /* Code generators */
  function singleCode(){
    var used=[];slots.forEach(function(g,i){if(g.some(function(r){return r.some(function(v){return v;});}))used.push(i);});
    if(!used.length)return'// Draw on the grid, then copy this code';
    var c='// LCD Custom Characters \u2014 eElectronicParts.com\n\n#include <LiquidCrystal.h>\n\n';
    used.forEach(function(i){c+='byte char'+i+'[8] = {\n';slots[i].forEach(function(row,ri){c+='  B'+row.join('')+(ri<7?',':(i,ri))+' // Row '+ri+'\n';});c+='};\n\n';});
    c+='void setup() {\n  lcd.begin('+lCols()+', '+lRows()+');\n';
    used.forEach(function(i){c+='  lcd.createChar('+i+', char'+i+');\n';});
    c+='\n';used.forEach(function(si,idx){c+='  lcd.setCursor('+idx+', 0);\n  lcd.write(byte('+si+'));\n';});
    c+='}\n\nvoid loop() { }\n';return c;
  }
  function bigCode(bs){
    var c='// Big Character (3x2 cells = 15x16 pixels) for '+lcdType+'\n// eElectronicParts.com\n\n#include <LiquidCrystal.h>\n\n';
    for(var i=0;i<6;i++){c+='byte big'+i+'[8] = {\n';bs[i].forEach(function(row,ri){c+='  B'+row.join('')+(ri<7?',' :' ')+'\n';});c+='};\n\n';}
    c+='void showBigChar(int col, int row) {\n';
    for(var j=0;j<6;j++)c+='  lcd.createChar('+j+', big'+j+');\n';
    c+='\n';for(var sr=0;sr<2;sr++)for(var sc=0;sc<3;sc++){var idx=sr*3+sc;c+='  lcd.setCursor(col+'+sc+', row+'+sr+');\n  lcd.write(byte('+idx+'));\n';}
    c+='}\n\nvoid setup() {\n  lcd.begin('+lCols()+', '+lRows()+');\n  showBigChar(0, 0);\n}\n\nvoid loop() { }\n';return c;
  }

  /* ═══ EVENTS ═══ */
  function bindEvents(){
    q('#lcd-reset').addEventListener('click',function(){slots=[];for(var i=0;i<8;i++)slots.push(mg(5,8));act=0;bigGrid=mg(15,16);dispTxt='Custom: \\0 \\1 \\2';showLib=false;render();});
    q('#lcd-theme').addEventListener('click',function(){dk=!dk;localStorage.setItem('lcd-theme',dk?'dark':'light');render();});
    qa('.lcd-tab').forEach(function(b){b.addEventListener('click',function(){mode=this.dataset.mode;render();});});
    qa('[data-lcd]').forEach(function(b){b.addEventListener('click',function(){lcdType=this.dataset.lcd;render();});});
    qa('.lcd-color-dot').forEach(function(d){d.addEventListener('click',function(){lcdClr=this.dataset.clr;render();});});

    /* Grid painting */
    var gridEl=q('#lcd-grid')||q('#lcd-big-grid');
    if(gridEl){
      gridEl.addEventListener('mousedown',function(e){var el=e.target;if(!el.classList.contains('lcd-cell'))return;e.preventDefault();
        var r=+el.dataset.r,c=+el.dataset.c,isBig=el.dataset.big;
        var grid=isBig?bigGrid:slots[act];
        paintVal=grid[r][c]?0:1;painting=true;grid[r][c]=paintVal;render();});
      gridEl.addEventListener('mousemove',function(e){if(!painting)return;var el=e.target;if(!el.classList.contains('lcd-cell'))return;
        var r=+el.dataset.r,c=+el.dataset.c,isBig=el.dataset.big;
        (isBig?bigGrid:slots[act])[r][c]=paintVal;render();});
    }
    document.addEventListener('mouseup',function(){painting=false;});

    /* Slots */
    qa('.lcd-slot').forEach(function(s){s.addEventListener('click',function(){act=+this.dataset.slot;render();});});

    /* Display text */
    var dispEl=q('#lcd-disp');
    if(dispEl)dispEl.addEventListener('input',function(){dispTxt=this.value;render();});

    /* Tools */
    qa('[data-tool]').forEach(function(b){b.addEventListener('click',function(){
      var t=this.dataset.tool,isBig=this.dataset.type==='big';
      var grid=isBig?bigGrid:slots[act];var cols=isBig?15:5,rows=isBig?16:8;
      if(t==='clear'){if(isBig)bigGrid=mg(15,16);else slots[act]=mg(5,8);}
      else if(t==='invert'){for(var r=0;r<rows;r++)for(var c=0;c<cols;c++)grid[r][c]=grid[r][c]?0:1;}
      else if(t==='l'){grid.forEach(function(r){r.shift();r.push(0);});}
      else if(t==='r'){grid.forEach(function(r){r.pop();r.unshift(0);});}
      else if(t==='u'){grid.shift();grid.push(new Array(cols).fill(0));}
      else if(t==='d'){grid.pop();grid.unshift(new Array(cols).fill(0));}
      render();
    });});

    /* Symbol library */
    var libToggle=q('#lcd-lib-toggle');
    if(libToggle)libToggle.addEventListener('click',function(){showLib=!showLib;render();});
    qa('.lcd-lib-item').forEach(function(el){el.addEventListener('click',function(){
      var g=SYM[this.dataset.cat][this.dataset.sym];
      slots[act]=g.map(function(r){return r.slice();});render();
    });});

    /* Big digit presets */
    qa('[data-bd]').forEach(function(b){b.addEventListener('click',function(){
      bigGrid=BD16[this.dataset.bd].map(function(r){return r.slice();});render();
    });});
    var bigClear=q('#lcd-big-clear');
    if(bigClear)bigClear.addEventListener('click',function(){bigGrid=mg(15,16);render();});

    /* Copy */
    var copyBtn=q('#lcd-copy');
    if(copyBtn)copyBtn.addEventListener('click',function(){
      var pre=q('#lcd-code-pre');var text=pre.textContent;
      if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(text).then(function(){copyBtn.textContent='Copied!';copyBtn.classList.add('lcd-copied');setTimeout(function(){copyBtn.textContent='Copy';copyBtn.classList.remove('lcd-copied');},1500);});}
    });
  }

  /* Preload demo symbols */
  slots[0]=SYM['Hearts & Stars']['Heart'].map(function(r){return r.slice();});
  slots[1]=SYM['Weather']['Thermo'].map(function(r){return r.slice();});
  slots[2]=SYM['UI Elements']['DegC'].map(function(r){return r.slice();});
  render();
  /* Recalc after first layout */
  setTimeout(function(){updateDsz();render();},100);
}

function autoInit(){document.querySelectorAll('.lcd-character-designer').forEach(function(el){if(el.dataset.lcdInit)return;el.dataset.lcdInit='1';initLCD(el);});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(autoInit,50);});
else setTimeout(autoInit,50);
})();
